export default __webpack_public_path__ + "ac50fa30e798a65398210dddbf3f4abf.svg";